import { useRef, useState, useEffect } from "react";
import "../../css/Segment.css";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-segmented-control-component
 */
const Segment = ({
  descricao,
  name,
  segments,
  callback,
  defaultIndex,
  controlRef,
  w = 55
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex);
  const componentReady = useRef();

  // Determine when the component is "ready"
  useEffect(() => {
    componentReady.current = true;
  }, []);

  useEffect(() => {
    // console.log('Segments', segments)
    if (segments[activeIndex]?.ref){
      const activeSegmentRef = segments[activeIndex]?.ref;
    
      const { offsetWidth, offsetLeft } = activeSegmentRef?.current;
      const { style } = controlRef.current;

      style.setProperty("--highlight-width", `${offsetWidth}px`);
      style.setProperty("--highlight-x-pos", `${offsetLeft}px`);

    }
  }, [activeIndex, callback, controlRef, segments]);

  const onInputChange = (value, index) => {
    setActiveIndex(index);
    callback(value, index);
  };

  return (
    <div className="controls-container" ref={controlRef}>
        <div style={{width: `${w}%`, textAlign: 'left'}}>{descricao}</div>
      <div className={`controls ${componentReady.current ? "ready" : "idle"}`}>
        {segments?.map((item, i) => (
          <div
            key={item.value}
            className={`segment ${i === activeIndex ? "active" : "inactive"}`}
            ref={item.ref}
          >
            <input
              type="radio"
              value={item.value}
              id={item.label}
              name={name}
              onChange={() => onInputChange(item.value, i)}
              checked={i === activeIndex}
            />
            <label htmlFor={item.label}>{item.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Segment;
